module.exports = __webpack_public_path__ + "media/images/photo12-61acb7a532290dbdf4e56795cd0c6508.png";